var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOldBrowser())?_c('div',{staticClass:"banner"},[_c('div',{staticClass:"con"},[_vm._v(" Evtl. unterstützt Ihr Browser nicht alle Features dieser Webseite. Bei Anzeigeproblemen empfehlen wir Chrome oder Firefox zu nutzen. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }